// extracted by mini-css-extract-plugin
export default {"root":"tweet-container_root__iLaom","article":"tweet-container_article__1kFxx"};